module.exports = __webpack_public_path__ + "static/img/icon1.a7228c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/dataCenter/icon1.png
// module id = 2gnB
// module chunks = 1